const KatharinaColours = [
  '#64B5F6',
  '#7986CB',
  '#FFB74D',
  '#EF5350',
  '#78909C',
  '#9575CD',
  '#7AD7E3',
  '#80CBC4',
  '#81C784',
  '#AED581',
  '#DEE263',
  '#FF7043'
]

const RedesignColours = [
  '#12c0df',
  '#72f0f9',
  '#3d058b',
  '#627680',
  '#c4c9dc',
  '400593'
]

export function isColorTooLight (hex: string): boolean {
  if (!hex || hex.length < 7) return false
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 240
}

export const Colours = Object.freeze({
  KatharinaColours,
  RedesignColours
})
